@if(loadingType == 'main'){
<div class="flex flex-col h-screen w-screen">
  <div class="flex h-16 xl:h-20 p-3 border-b border-gray-200 items-center">
    <div class="h-full w-45 xl:w-70"><div class="h-10 xl:h-14 w-32 xl:w-45 rounded-lg bg-gray-200 mx-5 shimmer"></div></div>
    <div class="flex-1">
      <div class="relative max-md:hidden">
        <span class="absolute -translate-y-1/2 pointer-events-none left-4 top-1/2">
          <svg class="fill-gray-500 dark:fill-gray-400" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M3.04175 9.37363C3.04175 5.87693 5.87711 3.04199 9.37508 3.04199C12.8731 3.04199 15.7084 5.87693 15.7084 9.37363C15.7084 12.8703 12.8731 15.7053 9.37508 15.7053C5.87711 15.7053 3.04175 12.8703 3.04175 9.37363ZM9.37508 1.54199C5.04902 1.54199 1.54175 5.04817 1.54175 9.37363C1.54175 13.6991 5.04902 17.2053 9.37508 17.2053C11.2674 17.2053 13.003 16.5344 14.357 15.4176L17.177 18.238C17.4699 18.5309 17.9448 18.5309 18.2377 18.238C18.5306 17.9451 18.5306 17.4703 18.2377 17.1774L15.418 14.3573C16.5365 13.0033 17.2084 11.2669 17.2084 9.37363C17.2084 5.04817 13.7011 1.54199 9.37508 1.54199Z" fill="" />
          </svg>
        </span>
        <input type="text" placeholder="Search or type command..." class="dark:bg-dark-900 h-11 w-full max-w-107.5 rounded-lg border border-gray-200 bg-transparent py-2.5 pl-12 pr-14 text-sm text-gray-800 shadow-theme-xs placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-800 dark:bg-white/3 dark:text-white/90 dark:placeholder:text-white/30 dark:focus:border-brand-800 shimmer" />
      </div>
    </div>
    <div class="h-10 w-10 xl:h-14 xl:w-14 rounded-full bg-gray-200 mx-2 xl:mx-3 shimmer"></div>
    <div class="h-10 w-10 xl:h-14 xl:w-14 rounded-full bg-gray-200 mx-2 xl:mx-3 shimmer"></div>
    <div class="h-10 w-10 xl:h-14 xl:w-14 rounded-full bg-gray-200 mx-2 xl:mx-3 shimmer"></div>
  </div>

  <div class="flex h-[calc(100%-var(--spacing)*16)] xl:h-[calc(100%-var(--spacing)*20)]">
    <div class="h-full w-0 xl:w-70 p-4 xl:border-r border-gray-200">
      <div class="w-full h-10 my-3 rounded-lg bg-gray-200 shimmer"></div>
      <div class="w-full h-10 my-3 rounded-lg bg-gray-200 shimmer"></div>
      <div class="w-full h-10 my-3 rounded-lg bg-gray-200 shimmer"></div>
      <div class="w-full h-10 my-3 rounded-lg bg-gray-200 shimmer"></div>
      <div class="w-full h-10 my-3 rounded-lg bg-gray-200 shimmer"></div>
      <div class="w-full h-10 my-3 rounded-lg bg-gray-200 shimmer"></div>
    </div>
    <div class="flex-1 w-full xl:w-[calc(100%-var(--spacing)*70)]">
      <div class="grid gap-6 p-6">
        <div class="bg-gray-200 h-45 rounded-3xl shimmer"></div>
        <div class="grid gap-5 grid-cols-3">
          <div class="bg-gray-200 h-55 rounded-2xl shimmer"></div>
          <div class="bg-gray-200 h-55 rounded-2xl shimmer"></div>
          <div class="bg-gray-200 h-55 rounded-2xl shimmer"></div>
        </div>
      </div>
    </div>
  </div>
</div>
}
@else if(loadingType == 'content'){
<div class="grid gap-6 p-6">
  <div class="bg-gray-200 h-45 rounded-3xl shimmer"></div>
  <div class="grid gap-5 grid-cols-3">
    <div class="bg-gray-200 h-55 rounded-2xl shimmer"></div>
    <div class="bg-gray-200 h-55 rounded-2xl shimmer"></div>
    <div class="bg-gray-200 h-55 rounded-2xl shimmer"></div>
  </div>
</div>
}
@else if(loadingType == 'surveyBuilder'){
<div class="flex h-full">
  <div class="h-full w-0 lg:w-70 p-4 xl:border-r border-gray-200">
    <div class="w-full h-20 my-3 rounded-lg bg-gray-200 shimmer"></div>
    <div class="w-full h-20 my-3 rounded-lg bg-gray-200 shimmer"></div>
    <div class="w-full h-20 my-3 rounded-lg bg-gray-200 shimmer"></div>
    <div class="w-full h-20 my-3 rounded-lg bg-gray-200 shimmer"></div>
    <div class="w-full h-20 my-3 rounded-lg bg-gray-200 shimmer"></div>
    <div class="w-full h-20 my-3 rounded-lg bg-gray-200 shimmer"></div>
  </div>
  <div class="flex-1 w-full lg:w-[calc(100%-var(--spacing)*70)]">
    <div class="grid gap-6 p-6">
      <div class="bg-gray-200 h-15 rounded-3xl shimmer"></div>
      <div class="bg-gray-200 h-15 rounded-3xl shimmer"></div>
      <div class="grid gap-5 grid-cols-3">
        <div class="bg-gray-200 h-15 rounded-2xl shimmer"></div>
        <div class="bg-gray-200 h-15 rounded-2xl shimmer"></div>
        <div class="h-15 rounded-2xl"></div>
      </div>
      <div class="grid gap-5 grid-cols-3">
        <div class="bg-gray-200 h-15 rounded-2xl shimmer"></div>
        <div class="bg-gray-200 h-15 rounded-2xl shimmer"></div>
        <div class="h-15 rounded-2xl"></div>
      </div>
      <div class="bg-gray-200 h-15 rounded-3xl shimmer"></div>
    </div>
  </div>
</div>
}